/** @file Check list in a fieldset: one checkbox per option; the result keeps the options' order. */
import { Checkbox } from './Checkbox';
import './tokens.css';
import './CheckList.css';

/** Props of CheckList; options are shown as given (entity names, scope ids). */
export interface CheckListProps {
  /** Already-translated legend. */
  legend: string;
  options: readonly string[];
  picked: readonly string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
}

/** Renders nothing for an empty option list. */
export function CheckList({ legend, options, picked, onChange, disabled = false }: CheckListProps) {
  if (options.length === 0) return null;
  const toggle = (value: string): void => { onChange(options.filter((o) => (o === value ? !picked.includes(o) : picked.includes(o)))); };
  return (
    <fieldset className="p2-check-list" disabled={disabled}>
      <legend>{legend}</legend>
      {options.map((value) => (
        <Checkbox key={value} label={value} checked={picked.includes(value)} disabled={disabled} onChange={() => { toggle(value); }} />
      ))}
    </fieldset>
  );
}
